import { GridLayer } from 'react-leaflet'
import { observer } from 'mobx-react'
import { inject } from 'mobx-react'
import _ from 'lodash'

// leaflet google maps provider
require('leaflet.gridlayer.googlemutant')

// Wrap the leaflet google plugin so it works like
// a react-leaflet component
@inject(allStores => ({ uiStore: allStores.uiStore }))
@observer class GoogleLayer extends GridLayer {
  initLayer = () => {
    this.leafletElement = window.L.gridLayer.googleMutant({ ...this.props, styles: [] })
    this.refreshLayer()

    if (this.props.uiStore) {
      this.props.uiStore.forceRefreshTiles = () => {
        // Defensive checks and slight delay for timing issues
        setTimeout(() => {
          if (this.leafletElement && this.leafletElement._map) {
            this.forceRefreshTiles()
          }
        }, 100)
      }
    }
  }

  refreshLayer () {
    _.defer(() => {
      // Refresh tiles without moving the camera. The old tiny zoom change
      // could replace a queued POI zoom animation with the previous scale.
      const layer = this.leafletElement
      if (layer && layer._map) layer.redraw()
    })
  }

  forceRefreshTiles () {
    if (this.leafletElement && this.leafletElement._map) {
      if (this.leafletElement._mutant && typeof this.leafletElement._mutant.setMapTypeId === 'function' && this.props.type) {
        this.leafletElement._mutant.setMapTypeId(this.props.type)
      }
      this.refreshLayer()
    }
  }

  componentWillMount () {
    super.componentWillMount()
    this.initLayer()
  }

  componentWillUpdate (props) {
    if (this.leafletElement && this.leafletElement._mutant) {
      try {
        if (typeof this.leafletElement._mutant.setMapTypeId === 'function' && props.type) {
          this.leafletElement._mutant.setMapTypeId(props.type)
        }
      } catch (e) {}
    }
    this.refreshLayer()
  }

  componentWillUnmount () {
    if (this.props.uiStore && this.props.uiStore.forceRefreshTiles) {
      this.props.uiStore.forceRefreshTiles = () => {}
    }
    if (super.componentWillUnmount) {
      super.componentWillUnmount()
    }
  }
}

export default GoogleLayer
